const translations = {
    'lang.en': '🇬🇧',
    'lang.pl': '🇵🇱',
};

export default translations;
